import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Loader2, Mail, Phone } from "lucide-react";

export default function AdminLeads() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    api.get("/leads/all").then(r => setItems(r.data)).catch(()=>{}).finally(()=>setLoading(false));
  }, []);
  return (
    <div className="space-y-5">
      <div>
        <h2 className="text-2xl font-bold text-white" style={{fontFamily:'Outfit'}}>Leads</h2>
        <p className="text-slate-400 text-sm">{items.length} contact form submissions</p>
      </div>
      {loading ? <div className="flex justify-center py-12"><Loader2 className="animate-spin text-blue-400"/></div> : (
        <div className="space-y-3">
          {items.length === 0 ? (
            <div className="card p-8 text-center text-slate-400">No leads yet.</div>
          ) : items.map(l => (
            <div key={l.id} className="card p-5">
              <div className="flex items-start justify-between flex-wrap gap-3">
                <div>
                  <div className="text-white font-semibold">{l.name}</div>
                  <div className="text-sm text-slate-400 flex items-center gap-3 mt-1 flex-wrap">
                    <a href={`mailto:${l.email}`} className="inline-flex items-center gap-1 hover:text-blue-400"><Mail size={12}/> {l.email}</a>
                    <a href={`tel:${l.phone}`} className="inline-flex items-center gap-1 hover:text-blue-400"><Phone size={12}/> {l.phone}</a>
                    <span className="tag">{l.service}</span>
                  </div>
                </div>
                <div className="text-xs text-slate-500">{new Date(l.created_at).toLocaleString()}</div>
              </div>
              <p className="mt-3 text-slate-300 text-sm leading-relaxed">{l.message}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
